import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── RevenueIQ ───────────────────────────────────────────────────────────────────
// Persona: Finance / RevOps
// Data sources: See constants/modules.js

const KPIs = [
  { label: "ARR", value: "$7.7M", delta: "+18% YoY", color: "#059669" },
  { label: "MRR", value: "$642K", delta: "+$48K MoM", color: "#059669" },
  { label: "New Bookings", value: "$1.2M", delta: "Q2 total", color: "#059669" },
  { label: "Expansion Rev", value: "$340K", delta: "+28% QoQ", color: "#059669" },
  { label: "Churned ARR", value: "$82K", delta: "1.1% rate", color: "#e11d48" },
  { label: "Rev Attainment", value: "94%", delta: "vs $13.2M plan", color: "#d97706" }
];
const CHART_DATA = [
  {
    "month": "Jan",
    "New": 320,
    "Expansion": 180,
    "Churn": -65
  },
  {
    "month": "Feb",
    "New": 380,
    "Expansion": 210,
    "Churn": -72
  },
  {
    "month": "Mar",
    "New": 410,
    "Expansion": 240,
    "Churn": -68
  },
  {
    "month": "Apr",
    "New": 390,
    "Expansion": 260,
    "Churn": -75
  },
  {
    "month": "May",
    "New": 450,
    "Expansion": 310,
    "Churn": -80
  },
  {
    "month": "Jun",
    "New": 520,
    "Expansion": 340,
    "Churn": -82
  }
];

export default function RevenueIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Revenue Waterfall — New vs Expansion vs Churn</p>
        <ResponsiveContainer width="100%" height={240}>
          <BarChart data={CHART_DATA} barGap={4}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="month" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Bar dataKey="New" fill="#2563eb" radius={[4,4,0,0]} />
          <Bar dataKey="Expansion" fill="#60a5fa" radius={[4,4,0,0]} />
          <Bar dataKey="Churn" fill="#e11d48" radius={[4,4,0,0]} />
        </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Expansion revenue growing faster than new — a sign of strong product-market fit and healthy land-and-expand motion.</p>
        </div>
      </div>
    </div>
  );
}
